module.exports = __webpack_public_path__ + "static/media/G05.b6989f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/decors/G05.png
// module id = 218
// module chunks = 0